import { createLearnosityItem, listLearnosityItem, createLearnosityAssessment, getAssessmentDetail, getAssessmentDetail2, startAssessment,
updateLaunchedAttempt, populateAttemptReport, getAssessmentAttemptForClass, getFieldsForClassReport, populateAttemptReportForUser, saveActivitySuccess,
populateAttemptManualGradingReportForUser, generateSignedRequestForActivity, getLibrariesForUser, startManualGradingForUser, updateAttemptManualGrade,
populateManuallyGradedReportWizardForUser, getUngradedAttempts, getRichHtmlAssessment, startRichHtmlAssessment, populateRichHtmlAssessmentReport,
getFieldsForQuestionLevelClassReport, getAttemptSummaryForClass, launchLocalPracticeReview, saveUserCareerCriteriaList, saveUserTopSkillList,
saveUserMostEnergizeWorkList, getAllLibrariesForUser, populateAttemptAIReport, saveUserConversationQuestionMap, saveUserMostInterestingIdeaList, getDiagnosticTestReportForIns, getDiagnosticTestReport, postUploadDiagnosticLogicMappingCsvFile } from '../api'

export const createItem = ({ state, commit }, { router, reference }) => {
  createLearnosityItem(router, reference)
}

export const listItem = ({ state, commit }, router) => {
  listLearnosityItem(router)
}

export const createAssessment = ({ state, commit }) => {
  return createLearnosityAssessment()
}

export const generateSignedRequest = ({ state, commit }, uuid) => {
  return generateSignedRequestForActivity(uuid)
}

export const saveActivityAtLearnosity = ({ state, commit }, data) => {
  return saveActivitySuccess(data)
}

export const loadAssessment = ({ state, commit }, uuid) => {
  return getAssessmentDetail(uuid).then(data => {
    commit('LOAD_ASSESSMENT', data.assessment)
    return data
  })
}

export const loadAssessment2 = ({ state, commit }, {uuid, userId}) => {
  return getAssessmentDetail2(uuid, userId).then(data => {
    commit('LOAD_ASSESSMENT', data.assessment)
    return data
  })
}

export const loadUngradedAttempts = ({ state, commit }, assessments) => {
  return getUngradedAttempts(assessments).then(data => {
    return data
  })
}

export const launchAssessment = ({ state, commit }, { uuid, courseId, sessionId }) => {
  return startAssessment(uuid, courseId, sessionId)
}

export const updateAttempt = ({ state, commit }, { sessionId, externalId, isFinished }) => {
  return updateLaunchedAttempt(sessionId, externalId, isFinished)
}

export const showAttemptReport = ({ state, commit }, { activityId, sessionId, courseId, userId }) => {
  return populateAttemptReport(activityId, sessionId, courseId, userId)
}

export const showAttemptAIReport = ({ state, commit }, { activityId, sessionId, courseId, userId }) => {
  return populateAttemptAIReport(activityId, sessionId, courseId, userId)
}

export const showClassAttemptReportForUser = ({ state, commit }, { userId, sessionId, courseId, widgetId }) => {
  return populateAttemptReportForUser(userId, sessionId, courseId, widgetId)
}

export const showClassAttemptManualGradingReportForUser = ({ state, commit }, { activityId, userId, sessionId }) => {
  return populateAttemptManualGradingReportForUser(activityId, userId, sessionId)
}

export const loadAssessmentAttemptForClass = ({ state, commit }, { assessmentId, users }) => {
  return getAssessmentAttemptForClass(assessmentId, users)
}

export const loadFieldsForClassReport = ({ state, commit }, { assessmentId }) => {
  return getFieldsForClassReport(assessmentId)
}

export const loadAllLibrariesForUser = ({ state, commit }) => {
    return getAllLibrariesForUser()
}

export const loadLibrariesForUser = ({ state, commit }, userId) => {
  if (state.learningSpaces.length === 0) {
    return getLibrariesForUser(userId).then(learningSpaces => {
      let folders = []
      let userObject = JSON.parse(localStorage.getItem('userobj'))
      let libraries = userObject.userPreferences ? userObject.userPreferences.learningSpaces : []
      $.each(learningSpaces, (index, learningSpace) => {
        for (var i = 0; i < libraries.length; i++) {
          if (libraries[i] === learningSpace.uuid) {
            folders.push(learningSpace)
            break
          }
        }
      })
      commit('LOAD_LEARNING_SPACES', folders)
      return folders
    })
  } else {
    return state.learningSpaces
  }
}

export const launchManualGradingForUser = ({ state, commit }, data) => {
  return startManualGradingForUser(data)
}

export const updateAttemptManualGradeForUser = ({ state, commit }, data) => {
  return updateAttemptManualGrade(data)
}

export const launchManuallyGradedReportWizardForUser = ({ state, commit }, data) => {
  return populateManuallyGradedReportWizardForUser(data)
}

export const loadRichHtmlAssessment = ({state, commit}, ancestor) => {
  return getRichHtmlAssessment(ancestor)
}

export const launchRichHtmlAssessment = ({ state, commit }, { uuid, sessionId, courseId }) => {
  return startRichHtmlAssessment(uuid, sessionId, courseId)
}

export const launchRichHtmlAssessmentReport = ({ state, commit }, { activityId, sessionId }) => {
  return populateRichHtmlAssessmentReport(activityId, sessionId)
}

export const loadFieldsForQuestionLevelClassReport = ({ state, commit }, assessmentId) => {
  return getFieldsForQuestionLevelClassReport(assessmentId)
}

export const loadAttemptSummary = ({ state, commit }, { assessmentId, attemptNumber, users }) => {
  return getAttemptSummaryForClass(assessmentId, attemptNumber, users)
}

export const showLocalPracticeReview = ({ state, commit }, { uuid, courseId, sessionId, responses }) => {
  return launchLocalPracticeReview(uuid, courseId, sessionId, responses)
}

export const updateUserCareerCriteriaList = ({ state, commit }, userCareerCriteriaList) => {
  return saveUserCareerCriteriaList(userCareerCriteriaList)
}

export const updateUserTopSkillList = ({ state, commit }, userTopSkillList) => {
  return saveUserTopSkillList(userTopSkillList)
}

export const updateUserMostEnergizeWorkList = ({ state, commit }, userMostEnergizeWorkList) => {
  return saveUserMostEnergizeWorkList(userMostEnergizeWorkList)
}

export const updateUserConversationQuestionMap = ({ state, commit }, userConversationQuestionMap) => {
  return saveUserConversationQuestionMap(userConversationQuestionMap)
}

export const updateUserMostInterestingIdeaList = ({ state, commit }, userMostInterestingIdeaList) => {
  return saveUserMostInterestingIdeaList(userMostInterestingIdeaList)
}

export const loadDiagnosticTestReport = ({ state, commit }, {courseId, assessmentId}) => {
  return getDiagnosticTestReport(courseId, assessmentId)
}
export const loadDiagnosticTestReportForIns = ({ state, commit }, {userId, courseId, assessmentId}) => {
  return getDiagnosticTestReportForIns(userId, courseId, assessmentId)
}

export const uploadDiagnosticLogicMappingCsvFile = ({ state, commit }, {fileData}) => {
  return postUploadDiagnosticLogicMappingCsvFile(fileData).then(res => {
    return res
  })
}



// WEBPACK FOOTER //
// ./src/app/assessment/vuex/actions.js